export const isPlanV3 = plan => {
  if (!plan) {
    return false;
  }
  return 'pricingVariants' in plan;
};
//# sourceMappingURL=is-plan-v3.js.map